export default __webpack_public_path__ + "static/media/cake.60bf67ab.png";